export const defaultColor = '#f17ab0 !important';